/** Angular Imports */
import { NgModule } from '@angular/core';

/** Angular Font Awesome Imports */
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import {
  faForward,
  faPlay,
  faBackward,
  faFileExcel,
  faWindowClose,
  faUser,
  faSignOutAlt,
  faPlusSquare,
  faMinusSquare,
  faDollarSign,
  faMoneyBill,
  faFillDrip,
  faUserCircle,
  faLock,
  faEye,
  faEyeSlash,
  faPlusCircle,
  faMinusCircle,
  faCheckCircle,
  faHandHoldingUsd,
  faHeartbeat,
  faFileInvoiceDollar

} from '@fortawesome/free-solid-svg-icons';

/**
 * Icons Module
 *
 * Angular Font Awesome module is exported here.
 */
@NgModule({
  exports: [FontAwesomeModule]
})
export class IconsModule {

  constructor(library: FaIconLibrary) {
    library.addIcons(
      faForward,
      faPlay,
      faBackward,
      faFileExcel,
      faWindowClose,
      faUser,
      faSignOutAlt,
      faPlusSquare,
      faMinusSquare,
      faDollarSign,
      faMoneyBill,
      faFillDrip,
      faUserCircle,
      faLock,
      faEye,
      faEyeSlash,
      faPlusCircle,
      faMinusCircle,
      faCheckCircle,
      faHandHoldingUsd,
      faHeartbeat,
      faFileInvoiceDollar,
    );
  }

}
